import React from 'react';
import { useTranslation } from 'react-i18next';
import TableGrid, { Body, Cell, Head, Row } from 'layout/atoms/TableGrid';
const COLUMNS = [
    ['80px', '1fr'],
    ['80px', '1fr'],
    ['120px', '2fr'],
    ['120px', '2fr'],
    ['100px', '1fr'],
    ['100px', '1fr'],
    ['80px', '1fr'],
    ['100px', '1fr'],
    ['60px', '60px'],
];
function OrdersList({ children }) {
    const { t } = useTranslation(['common', 'orders']);
    return (React.createElement(TableGrid, { columns: COLUMNS, rowBorders: true, columnBorders: true },
        React.createElement(Head, null,
            React.createElement(Row, { head: true },
                React.createElement(Cell, { align: "left" }, t('orders:number')),
                React.createElement(Cell, { align: "left" }, t('orders:season')),
                React.createElement(Cell, { align: "left" }, t('orders:model')),
                React.createElement(Cell, { align: "left" }, t('orders:supplier')),
                React.createElement(Cell, { align: "left" }, t('created_date')),
                React.createElement(Cell, { align: "left" }, t('modified_date')),
                React.createElement(Cell, { align: "left" }, t('modified')),
                React.createElement(Cell, { align: "left" }, t('orders:status')),
                React.createElement(Cell, null))),
        React.createElement(Body, null, children)));
}
export default OrdersList;
